module.exports = __webpack_public_path__ + "static/media/Rubik-Regular.09556186.ttf";